import { Row } from 'components-antd';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.scss';
import classNames from 'classnames';
import React from 'react';
import { SmartFormIcons } from 'components';
import { useSelector } from 'react-redux';
import { getUserRoleSelector } from 'store/selectors/user';
import { THIRD_PARTY } from 'settings/constants/roles';

type RevampedHeaderTypes = {
  title: string;
  titleClassName: string;
  actionButtons: React.ReactNode;
  className?: string;
};

export const RevampedHeader = (props: RevampedHeaderTypes) => {
  const { title, actionButtons, titleClassName, className } = props;
  const history = useHistory();
  const userRole = useSelector(getUserRoleSelector);

  const goToWorshopMainPage = () => {
    history.push('/workshop');
  };

  return (
    <div className={className}>
      <Row justify="space-between" align="middle" className={styles.headerRow}>
        {userRole === THIRD_PARTY ? (
          <div></div>
        ) : (
          <div onClick={goToWorshopMainPage} className={classNames(styles.backNavigation)}>
            <SmartFormIcons variant="back" />
          </div>
        )}
        <div className={classNames(styles.title, titleClassName)}>{title}</div>
        {actionButtons}
      </Row>
    </div>
  );
};
